import { fetcher } from '@commenda/utils';

export async function toggleChatRoomPin(chatRoomId: string) {
  const res = await fetcher(`chatRoom/${chatRoomId}/toggle-pin`, {
    method: 'POST',
  });

  return res;
}
